<template>
  <div>
    <form data-vv-scope="step-3-part-1">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Adjuntar Documento</h4>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <h5>Documento principal</h5>
        </div>
        <div class="col-md-4 d-flex align-items-end">
          <UploadFile
            permission="*"
            text="Seleccionar archivo"
            accept=".pdf,.rar,.zip,"
            :max-size-in-mb="30"
            v-model="step.mainFile"
            upload-to="ed"
            button-class="btn-block"
            container-class="w-100"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <h5>Documentos adicionales</h5>
        </div>
        <div class="col-md-4 d-flex align-items-end">
          <UploadFile
            permission="*"
            text="Seleccionar archivo"
            accept=".pdf,.rar,.zip,"
            :max-size-in-mb="30"
            v-model="additionalFile"
            upload-to="ed"
            button-class="btn-block"
            container-class="w-100"
            @input="addAdditionalFile()"
          />
        </div>
      </div>
      <div class="row mb-3" v-if="step.mainFile.name || step.additionalFiles.length">
        <div class="col-12">
          <b-table-simple hover small>
            <b-thead>
              <b-tr>
                <b-th scope="col">Nombre archivo</b-th>
                <b-th scope="col">Nombre documento</b-th>
                <b-th scope="col" class="text-center">Interno</b-th>
                <b-th scope="col" class="text-center">-</b-th>
              </b-tr>
            </b-thead>
            <b-tbody v-if="step.mainFile.name">
              <b-tr>
                <b-td>
                  <div v-tooltip="'Principal'" class="d-flex align-items-center">
                    <vs-icon icon="file_present" size="medium" class="mr-1"/>
                    {{step.mainFile.name}}
                  </div>
                </b-td>
                <b-td>
                  <vs-input class="w-100" v-model="step.mainFile.currentDescription"/>
                </b-td>
                <b-td>

                </b-td>
              </b-tr>
            </b-tbody>
            <b-tbody v-if="step.additionalFiles.length">
              <b-tr v-for="file in step.additionalFiles" :key="file.id">
                <b-td>
                  <div v-tooltip="'Principal'" class="d-flex align-items-center">
                    <vs-icon icon="file_present" size="medium" class="mr-1"/>
                    {{file.name}}
                  </div>
                </b-td>
                <b-td>
                  <vs-input class="w-100" v-model="file.currentDescription"/>
                </b-td>
                <b-td class="text-center">
                  <vs-checkbox class="ml-5 pl-5" v-model="file.interno"/>
                </b-td>
                <b-td class="text-center">
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    @click="removeAdditionalFile(file.id)"
                  >
                    remover
                  </b-button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="step-3-part-2">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Documentos Relacionados</h4>
        </div>
      </div>
      <div class="row mb-3" v-if="view === 'numOf'">
        <div class="col-md-6 mt-3">
          <vs-input
            class="w-100"
            label="Código RIF"
            name="rifCode"
            v-model="step.rifCode"
          />
        </div>
        <div class="col-md-6 mt-3">
          <vs-input
            class="w-100"
            label="Número expediente"
            name="documentNumber"
            data-cy="document-number"
            v-model="step.fileNumberEntry"
          />
        </div>
        <div class="col-md-6 mt-3">
          <vs-input
            class="w-100"
            label="Número RIDEX"
            name="rifCode"
            v-model="step.numberRidex"
          />
        </div>
        <div class="col-md-6 mt-3">
          <vs-input
            class="w-100"
            label="Número SAC"
            name="documentNumber"
            data-cy="sac-number"
            v-model="step.numberSac"
          />
        </div>
        <div class="col-md-6 mt-3">
          <vs-input
            class="w-100"
            label="Id Adquisiciones"
            name="rifCode"
            v-model="step.numberAcquisitions"
          />
        </div>
      </div>
      <div class="row mb-3" v-if="view === 'numOf'">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
      <div class="row mb-3" v-if="isMop">
        <div class="col-md-6">
          <vs-input
            class="w-100"
            label="Contrato SAFI"
            maxlength="10"
            name="safiContract"
            v-model="step.safiContract"
          />
        </div>
        <div class="col-md-12">
          <div class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to"
           style="height: 32px;font-size:12px; color:#673ab7 !important;"
          >
          <span class="span-text-validation">
            El número de Contrato SAFI en muchos casos es requerido, no lo olvides!
          </span>
          </div>
        </div>
      </div>
      <div class="row mb-3" v-if="isMop">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <list-all-document-types
            usage="referencias"
            class="w-100"
            autocomplete
            label="Tipo Documento"
            name="documentType"
            v-model="relatedDocument.type"
            :danger="errors.has('step-3-part-2.documentType')"
            :danger-text="errors.first('step-3-part-2.documentType')"
            v-validate="'required'"
            ref="documentTypes"
          />
        </div>
        <div class="col-md-6">
          <vs-input
            class="w-100"
            label="Nº Documento"
            name="relatedDocumentNumber"
            v-model="relatedDocument.number"
            v-validate="'required'"
            :danger="errors.has('step-3-part-2.relatedDocumentNumber')"
            :danger-text="errors.first('step-3-part-2.relatedDocumentNumber')"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 d-flex align-items-end justify-content-end">
          <vs-button
          data-cy="add-relationship-button"
          color="primary"
          icon="add"
          v-on:click="addRelatedDocument()"
          >
            Agregar relación
          </vs-button>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-table
            class="pb-2 mb-2"
            multiple
            v-model="step.relatedDocumentsSelected"
            no-data-text="No tienes documentos relacionados"
            :data="step.relatedDocuments"
          >
            <template slot="thead">
              <vs-th>Relacionado con</vs-th>
              <vs-th>Nº Documento</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                <vs-td :data="data[indextr].type">
                  {{ findLabelDocument(tr.type) }}
                </vs-td>
                <vs-td :data="data[indextr].number">
                  {{ tr.number }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import FindTypeDocumentMixin from '@/febos/chile/dnt/mixins/FindTypeDocumentMixin';
import ListAllDocumentTypes from '@/febos/chile/lists/components/ListAllDocumentTypes';
import FindLabelDocumentMixin from '@/febos/chile/dnt/mixins/FindLabelDocumentMixin';

export default {
  mixins: [WizardStep, FindTypeDocumentMixin, FindLabelDocumentMixin],
  components: {
    UploadFile,
    ListAllDocumentTypes
  },
  data() {
    const { wizard } = this.$route.params;
    return {
      view: wizard,
      error: {
        message: ''
      },
      step: {
        rifCode: '',
        fileNumberEntry: '',
        numberRidex: '',
        numberSac: '',
        numberAcquisitions: '',
        mainFile: {},
        additionalFiles: [],
        safiContract: '',
        relatedDocuments: [],
        relatedDocumentsSelected: [],
        ...this.draft
      },
      additionalFile: {},
      relatedDocument: {
        type: '',
        number: ''
      }
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'step.mainFile.name': function () {
      this.$validator.reset();
    }
  },
  computed: {
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('List', [
      'allDocumentsState'
    ]),
    isMop() {
      return this.company.iut === '61202000-0';
    }
  },
  methods: {
    findLabel(document) {
      return this.allDocumentsState.list
        .find((option) => option.value === document) || {};
    },
    async addAdditionalFile() {
      if (!Object.keys(this.additionalFile).length) {
        return;
      }

      if (this.additionalFile.failed) {
        // TODO: display error message.
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.step.additionalFiles.push(this.additionalFile);
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.step.additionalFiles = this.step.additionalFiles.filter((file) => file.id !== fileId);
    },
    async addRelatedDocument() {
      if (this.step.safiContract === '' && this.isMop) {
        this.$bvToast.toast(
          'Te recordamos que no estas ingresando el número de Contrato SAFI',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }

      const isValid = await this.validateForm('step-3-part-2');

      if (!isValid) {
        return;
      }

      const row = {
        id: this.relatedDocument.length,
        type: this.relatedDocument.type,
        number: this.relatedDocument.number
      };
      const isSelected = this.step.relatedDocumentsSelected
        .some((relatedDoc) => relatedDoc.id === row.id
          && relatedDoc.type === row.type && relatedDoc.number === row.number);

      if (!isSelected) {
        this.step.relatedDocuments.push(row);
        this.step.relatedDocumentsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste esta referencia',
          {
            title: '¡HEEEY!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }

      this.relatedDocument.type = '';
      this.relatedDocument.number = '';
      await this.$validator.reset();
    },
    async isValid() {
      const isValid = await this.validateForm('step-3-part-1');
      if (!isValid) {
        return false;
      }
      if (!this.step.safiContract && this.isMop) {
        return new Promise((resolve) => {
          this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: 'Heey!',
            text: 'No estas ingresando el número de Contrato SAFI, ¿Seguro que deseas continuar?',
            cancelText: 'Cancelar',
            acceptText: 'Confirmar',
            accept: () => resolve(true),
            cancel: () => resolve(false)
          });
        });
      }
      return true;
    }
  }
};

</script>
